import * as amplitudeInstances from '@/amplitude-events'

const featureTypes = {
  view: 'view',
  filters: 'filters',
  actions: 'actions'
}

function sendEvent ({ instanceName, featureName, functionName, metadata }) {
  if (!instanceName || !featureName || !functionName) return
  const feature = featureTypes[featureName]

  amplitudeInstances[instanceName].events[feature][functionName](metadata)
}

export default sendEvent
